import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.GetEnvelopeCertificate.IRequest;
type Response = Api.Core.Contract.GetEnvelopeCertificate.IResponse;
type Headers = Api.Core.Contract.GetEnvelopeCertificate.IHeaders;
const url = '/api/Sales/Contract/Envelope/Certificate/:envelopeId';
export default async function contractGetEnvelopeCertificateApi(params: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
    keepRawResponse: true,
  });
}
